

import { AttachmentsController } from './controllers/AttachmentsController';
import '../../models/requestDetailEdit';

import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';

export class AttachmentsDirective implements angular.IDirective {
    template = require('./templates/attachments.html');
    restrict = 'E';
    controller = AttachmentsController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit:"="
    };
    scope = {};
    replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new AttachmentsDirective();
    }
}

angular.module('deliveryCreate.app').directive('attachments', AttachmentsDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/attachments/attachmentsDirective.ts
 **/